import { render, staticRenderFns } from "./InternationalPhone.vue?vue&type=template&id=d4067b4a&"
import script from "./InternationalPhone.vue?vue&type=script&lang=js&"
export * from "./InternationalPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports